export type LanguagesType = 'en' | 'da';
export const LanguagesEnum = {
  Danish: 'da' as LanguagesType,
  English: 'en' as LanguagesType,
};
